import PropTypes from 'prop-types';
import React from 'react';

import { useTypewriter } from '../../../../hooks/useTypewriter';

import * as S from './Typewriter.styles.js';

export const Typewriter = ({
  words,
  autoloop,
  typeSpeed = 120,
  deleteSpeed = 90,
  delaySpeed = 1500,
}) => {
  const { text } = useTypewriter({
    words,
    autoloop,
    typeSpeed,
    deleteSpeed,
    delaySpeed,
  });

  return <S.Typewriter>{text}</S.Typewriter>;
};

Typewriter.propTypes = {
  autoloop: PropTypes.bool,
  delaySpeed: PropTypes.number,
  deleteSpeed: PropTypes.number,
  typeSpeed: PropTypes.number,
  words: PropTypes.shape([PropTypes.string]),
};
